import { useEffect } from "react";

// Fades out the static HTML app-shell loader (#initial-loader in index.html) once real
// content mounts. Rendered inside the top-level Suspense so it only fires after the first
// route chunk resolves — keeping the loader up that long avoids a spinner swap/flash on cold
// load. Idempotent: a no-op once the element is gone.
export default function AppReady() {
    useEffect(() => {
        const loader = document.getElementById("initial-loader");
        if (loader === null) {
            return;
        }
        loader.style.opacity = "0";
        const timeout = window.setTimeout(() => loader.remove(), 300);
        return () => window.clearTimeout(timeout);
    }, []);

    return null;
}
